import { EnvironmentProviders, Injectable, Provider } from "@angular/core";
import { ReceiptsRoutesProvider } from "./lib/routes/receipts.routes";

@Injectable({ providedIn: 'root' })
export class ReceiptsConfigService {
    constructor() {}
}

export const providereceipts = (): Array<Provider | EnvironmentProviders> => {
    return [
        { provide: ReceiptsRoutesProvider.getToken(), useClass: ReceiptsRoutesProvider, multi: true },
    ];
}